import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
// @mui
import { Box, Card, CardHeader } from '@mui/material';
// utils
import { forEach } from 'lodash';
import { useSelector } from 'react-redux';
import { fData } from '../../../utils/formatNumber';
// components
import { useChart } from '../../../components/chart';
import axiosInstance from '../../../utils/axiosInstance';

// ----------------------------------------------------------------------

AppCameraStorage.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  host: PropTypes.string.isRequired,
};

export default function AppCameraStorage({ title, subheader, host, ...other }) {
  const [chartData, setChartData] = useState([]);
  const chartLabels = chartData.map((i) => i.label);
  const chartSeries = chartData.map((i) => i.value);
  const cameraList = useSelector((state) => state.app.cameraList);

  const chartOptions = useChart({
    tooltip: {
      marker: { show: false },
      y: {
        formatter: (seriesName) => fData(Number(seriesName) * 1024 * 1024), // bytes
        title: {
          formatter: () => '',
        },
      },
    },
    plotOptions: {
      bar: { horizontal: true, barHeight: '28%', borderRadius: 2 },
    },
    xaxis: {
      categories: chartLabels,
    },
  });

  useEffect(() => {
    const parseRecordApiResponse = (obj) => {
      const parsedData = [];
      forEach(obj, (nestedObj, key) => {
        if (key !== 'total') {
          forEach(cameraList, (camera) => {
            if (camera.sensorId === key && camera.host === host) {
              const temp = {
                label: camera.name,
                value: nestedObj.sizeInMb,
              };
              parsedData.push(temp);
            }
          });
        }
      });
      setChartData(parsedData);
    };
    axiosInstance
      .get(`${window.location.protocol}//${host}/api/v1/storage/size`)
      .then((response) => {
        if (response.data) {
          parseRecordApiResponse(response.data);
        }
      })
      .catch((error) => {
        console.log('Failed to get VST record size', error);
      });
  }, [host, cameraList]);

  return (
    <Card {...other}>
      <CardHeader title={title} subheader={subheader} />

      <Box sx={{ mx: 3 }} dir="ltr">
        <ReactApexChart type="bar" series={[{ data: chartSeries }]} options={chartOptions} height={364} />
      </Box>
    </Card>
  );
}
